import { createFileRoute, Outlet } from '@tanstack/react-router';
import {
  PERMISSION_VEHICLE_GROUP_CUSTOMER,
  PERMISSION_VEHICLE_GROUP_PRIVATE,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';
import CarsGroups from '../../components/CarsGroups';

export const Route = createFileRoute('/_authenticated/cars_groups_settings')({
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [PERMISSION_VEHICLE_GROUP_CUSTOMER, PERMISSION_VEHICLE_GROUP_PRIVATE],
      ['read'],
      '/unauthorized',
      context
    );

    return {
      ...context,
      documentTitle: {
        main: 'carsGroups.carsGroups',
        suffix: 'menu.settings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: CarsGroupsRoute,
});

function CarsGroupsRoute() {
  return (
    <>
      <CarsGroups />
      <Outlet />
    </>
  );
}
